import { render } from "./Tab.vue?vue&type=template&id=21d349d0"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21d349d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21d349d0', __exports__)) {
    api.reload('21d349d0', __exports__)
  }
  
  module.hot.accept("./Tab.vue?vue&type=template&id=21d349d0", () => {
    api.rerender('21d349d0', render)
  })

}


export default __exports__